import React from 'react';

const About = () => {
  return (
    <>
      <h1>Github Lookup</h1>
      <p>Search and Fetch repositories from Github Users</p>
      <p>Version 1.0.0</p>
<p>Redesigned with <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-heart-fill" fill="red" xmlns="http://www.w3.org/2000/svg"> 
<path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"></path> 
</svg> by <a href="https://github.com/Aicirou">Aicirou</a> </p>
    </>
  );
};

export default About;
